







import { Login } from 'playboard-core';

export default {
  components: {
    Login
  },
  data: function () {
    return {
      scheduledEvents: [
        {
          id: 'winter',
          name: 'Wintertime',
          startDate: new Date('2019-12-22T00:00'),
          endDate: new Date('2020-03-20T00:00:00'),
          resources: {
            video: 'https://assets.empathybroker.com/resources/playboard/login/winter/video.mp4',
            poster: 'https://assets.empathybroker.com/resources/playboard/login/winter/poster.jpg',
            icon: 'https://assets.empathybroker.com/resources/playboard/login/winter/icon.gif'
          },
          location: {}
        }, {
          id: 'spring',
          name: 'Springtime',
          startDate: new Date('2020-03-20T00:00'),
          endDate: new Date('2020-06-20T00:00:00'),
          resources: {
            image: 'https://assets.empathybroker.com/resources/playboard/login/spring/image.jpg'
          },
          location: {
            name: 'Naranjo de Bulnes',
            surname: ', Asturias (Spain)'
          }
        }, {
          id: 'summer',
          name: 'Summertime',
          startDate: new Date('2020-06-20T00:00:00'),
          endDate: new Date('2020-09-23T00:00:00'),
          resources: {
            video: 'https://assets.empathybroker.com/resources/playboard/login/summer/video.mp4',
            poster: 'https://assets.empathybroker.com/resources/playboard/login/summer/poster.jpg',
            icon: 'https://assets.empathybroker.com/resources/playboard/login/summer/icon.png'
          },
          location: {}
        }, {
          id: 'autumn',
          name: 'Autumntime',
          startDate: new Date('2020-09-23T00:00:00'),
          endDate: new Date('2020-12-22T00:00:00'),
          resources: {
            video: 'https://assets.empathybroker.com/resources/playboard/login/autumn/video.mp4',
            poster: 'https://assets.empathybroker.com/resources/playboard/login/autumn/poster.jpg',
            icon: 'https://assets.empathybroker.com/resources/playboard/login/autumn/icon.png'
          },
          location: {
            name: 'Time for "Amagüestu"',
            surname: ', Asturias, Spain'
          }
        }
      ]
    };
  }
};

